<template>
  <div 
    v-if="answer.answer" 
    :class="{hint: answer.is_hint, 'colorized': forceHighlighted}" 
    :style="styleObj"
    class="ec-answer ec-placeholder">
    <span 
      v-show="effectedWarningEnabled" 
      :aria-label="this.$t('answers.change_warning_msg')"
      class="ec-answer-effected-warning-edge hint--bottom-left hint--medium">
      <i 
        class="fa fa-exclamation" 
        aria-hidden="true" />
    </span>
    <div class="ec-answer-main">
      <div 
        class="ec-answer-text" 
        v-html="answer.answer"/>
    </div>
    <div class="ec-answer-image"/>
    <AnswerDebug 
      v-if="answer.additional_informations"
      :debug-info="answer.additional_informations"
    />
  </div>
</template>
<script>
    import Answer from './Answer.vue'

    export default {
        name: "Placeholder",
        extends: Answer,
        computed: {
            isValid() {
                return true
            }
        }
    }
</script>